import { Sidebar } from './Sidebar'
import type WebModel from '../models/WebModel'

export class SidebarAtf extends Sidebar {
  slotName = 'sidebar'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)
    this.adUnitId = 'sidebar_atf'
  }
}
